// src/AdSense.js
import { useEffect } from 'react';

// AdSense component for displaying ads
const AdSense = ({ 
  client = process.env.REACT_APP_ADSENSE_CLIENT, 
  slot,
  format = 'auto',
  responsive = true,
  style = { display: 'block' }
}) => {
  useEffect(() => {
    try {
      if (window.adsbygoogle && client) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (e) {
      console.error('AdSense error:', e);
    }
  }, [client]);

  if (!client) {
    return null; // Don't show ads if client ID not configured
  }

  return (
    <ins
      className="adsbygoogle"
      style={style}
      data-ad-client={client}
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive={responsive}
    />
  );
};

// Initialize AdSense script
export const initAdSense = () => {
  const client = process.env.REACT_APP_ADSENSE_CLIENT;
  
  if (client && !document.querySelector('script[src*="adsbygoogle"]')) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${client}`;
    script.crossOrigin = 'anonymous';
    document.head.appendChild(script);
  }
};

export default AdSense;
